import {
  Component,
  OnInit,
  Input,
  ComponentFactoryResolver,
  Inject,
  forwardRef
} from '@angular/core';
import {
  DataEntity,
  DocumentDataEntity
} from '../../../../../models/data-entities';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import {
  WorkflowContextService,
  DocumentService
} from '../../../../../services';
import { Document } from '../../../../../models';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-document-data-entity-view',
    templateUrl: './document-data-entity-view.component.html',
    styleUrls: ['./document-data-entity-view.component.css'],
    standalone: false
})
export class DocumentDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
  @Input() entity: DocumentDataEntity;
  @Input() applicationId: string;
  @Input() parentEntityId: string;
  documentTemplateCode: string;
  // documents: Document[];
  templateForPermitForm:boolean=false


  constructor(
    public layoutService: LayoutService, 
    componentFactoryResolver: ComponentFactoryResolver,
    @Inject(forwardRef(() => DocumentService))
    public uploadService: DocumentService,
    @Inject(forwardRef(() => WorkflowContextService))
    private _context: WorkflowContextService
  ) {
    super(layoutService, componentFactoryResolver, _context);
     //added by priya 19-12-2025

    layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
     //end by priya 19-12-2025
  }

  ngOnInit() {
    this.applicationId = this.applicationId || this._context.applicationId;
    if (this.parentEntityId || this.entity.parent) {
      this.parentEntityId = this.parentEntityId || this.entity.parent.id;
    }
    this.documentTemplateCode = this.entity.templateCode;
    this.getDocuments();
  }

  getDocuments() {
    if (
      this.applicationId &&
      this.parentEntityId &&
      this.documentTemplateCode
    ) {
      if ((this.entity.documents || []).length === 0 && this.entity.value) {
        this.entity.documents = JSON.parse(
          this.entity.value.replace(/\\"/g, '"')
        );
      }
    }
  }
}
